import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import ImportData from "./pages/ImportData";
import CardioLog from "./pages/CardioLog";
import BetaLanding from "./pages/BetaLanding";
import BetaSignups from "./pages/BetaSignups";
import Pricing from './pages/Pricing';
import JoinTrainer from './pages/JoinTrainer';

function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/import" component={ImportData} />
      <Route path="/cardio" component={CardioLog} />
      <Route path="/beta" component={BetaLanding} />
      <Route path="/admin/beta" component={BetaSignups} />
      <Route path="/pricing" component={Pricing} />
      <Route path="/join/:code" component={JoinTrainer} />
      <Route path="/404" component={NotFound} />
      {/* Final fallback route */}
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="light">
        <TooltipProvider>
          <Toaster position="bottom-right" theme="light" />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
